import { emptyFragment } from '@execonline-inc/execonline-ui';
import { just } from 'maybeasy';
import { observer } from 'mobx-react';
import { findLinkBy } from '../../Links';
import { rootResourceStore } from '../../RootResourceStore';
import FooterCopyrightNotice from './FooterCopyrightNotice';
import FooterDivider from './FooterDivider';
import FooterLanguageSwitcher from './FooterLanguageSwitcher';
import {
  CookiePreferencesLink,
  PrivacyPolicyLink,
  SitemapLink,
  TermsOfUseLink,
} from './FooterLinks';

function Footer() {
  return just({})
    .assign('privacyLink', findLinkBy({ rel: 'privacy' }, rootResourceStore.links))
    .assign('termsLink', findLinkBy({ rel: 'terms_and_conditions' }, rootResourceStore.links))
    .map(({ privacyLink, termsLink }) => (
      <footer
        className="mt-16 flex flex-wrap items-center justify-center p-2.5 opacity-70"
        data-test-footer={true}
        role="contentinfo"
      >
        <FooterCopyrightNotice className="text-neutral-900" />
        <FooterDivider />
        <PrivacyPolicyLink href={privacyLink.href} />
        <FooterDivider />
        <TermsOfUseLink href={termsLink.href} />
        <CookiePreferencesLink />
        <FooterDivider />
        <SitemapLink href="/p3/sitemap" />
        <FooterLanguageSwitcher />
      </footer>
    ))
    .getOrElse(emptyFragment);
}

export default observer(Footer);
